
import React from "react";

const XDRBenefitsSection: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold mb-5" id="benefits">Benefits of AI-XDR</h2>
      <p className="text-lg text-gray-700 mb-6">
        Organizations implementing AI-based XDR solutions report significant improvements across multiple 
        security metrics. While individual results vary based on implementation and organizational factors, 
        the following benefits are consistently observed:
      </p>
      
      <div className="space-y-6 mb-10">
        <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-[#8932c8]">
          <h4 className="font-bold text-lg mb-2">Faster Threat Detection</h4>
          <p className="text-gray-700">
            AI-XDR solutions typically reduce mean time to detect (MTTD) threats by 70-85% compared to 
            traditional security tools. This speed is critical in minimizing potential damage, as research 
            shows that the first 24 hours of a breach are when most damage occurs.
          </p>
        </div>
        
        <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-[#8932c8]">
          <h4 className="font-bold text-lg mb-2">Reduced False Positives</h4>
          <p className="text-gray-700">
            Organizations report 60-90% fewer false positives after implementing AI-XDR. This dramatic 
            reduction addresses one of the most significant challenges in security operations - alert 
            fatigue that leads to missed threats and analyst burnout.
          </p>
        </div>
        
        <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-[#8932c8]">
          <h4 className="font-bold text-lg mb-2">Comprehensive Visibility</h4>
          <p className="text-gray-700">
            AI-XDR provides a unified view across previously disconnected security domains, eliminating 
            blind spots where threats could hide. This visibility extends across on-premises, cloud, and 
            hybrid environments, covering the entire modern attack surface.
          </p>
        </div>
        
        <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-[#8932c8]">
          <h4 className="font-bold text-lg mb-2">Accelerated Response</h4>
          <p className="text-gray-700">
            Mean time to respond (MTTR) typically improves by 50-80% with AI-XDR solutions. Automated 
            response playbooks can instantly contain threats across multiple security layers, preventing 
            lateral movement and limiting damage scope.
          </p>
        </div>
        
        <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-[#8932c8]">
          <h4 className="font-bold text-lg mb-2">Operational Efficiency</h4>
          <p className="text-gray-700">
            Security teams report 30-50% improvements in operational efficiency after implementing AI-XDR. 
            This allows skilled security professionals to focus on strategic initiatives rather than 
            routine alert triage and investigation.
          </p>
        </div>
        
        <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-[#8932c8]">
          <h4 className="font-bold text-lg mb-2">Improved Compliance</h4>
          <p className="text-gray-700">
            AI-XDR solutions provide comprehensive audit trails and evidence collection that streamline 
            compliance reporting for regulations like GDPR, HIPAA, PCI DSS, and others. This can reduce 
            compliance-related workloads by up to 40%.
          </p>
        </div>
      </div>
    </div>
  );
};

export default XDRBenefitsSection;
